import { render } from "./EditProfileSkillRankingModal.vue?vue&type=template&id=6f3d3be6&scoped=true"
import script from "./EditProfileSkillRankingModal.vue?vue&type=script&lang=js"
export * from "./EditProfileSkillRankingModal.vue?vue&type=script&lang=js"

import "./EditProfileSkillRankingModal.vue?vue&type=style&index=0&id=6f3d3be6&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3d3be6"]])

export default __exports__